import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_rc-rate@2.5.0@rc-rate/es/index.js
// module id = 770
// module chunks = 0